import { Button, Switch } from "@material-ui/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "../Accounts.module.scss";
import {
  calculateSubscriptionPayment,
  getAmounts,
  getCustomerBalanceAmount,
  getPromotionCodes,
  getStripeConfigs,
  sendEmailForAchPaymentDetail,
  SuccesDownGradeEmail,
  SuccesUpdateSubscriptionEmail,
  updatePaymentVerification,
  UpgradeQuantitySubscription,
  UpgradeStripeSubscription,
} from "../../../services/apiservices/users";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import AuthContext from "../../../hooks/authContext";
import { STRIPE_PUBLISHABLE_KEY } from "../../../services/config";
import { withStyles } from "@material-ui/core/styles";
import PaymentFlowContet from "./PaymentFlowContet";
import CommonContext from "../../../hooks/commonContext";
import FeatureComparison from "./Features";
import TestimonialPage from "./Testimonial";
import { DownGradeDiaog } from "../../../components/DialogComponent/SupplyDataDialog";
import PaymentSuccess, { SuccessDowngradeDialog } from "./PaymentSuccess";
import { useToast } from "../../../hooks/useToast";
import SubscriptionList from "./SubscriptionList";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";
import ACHVerification from "./ACHverification";
import PaymentMethodsList from "./PaymentMethodsList";

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const UpgradePage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [prices, setPrices] = useState();
  const [yearlyPrice, setYearlyPrices] = useState();
  const [name, setName] = useState();
  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [newAmounts, setNewAmounts] = useState();
  const cardRef = useRef();
  const messagesRef = useRef();
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isAnnual, setIsAnnual] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [downgradeDialog, setDownGradeDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [newPrice, setNewPrice] = useState(null);
  const [code, setCode] = useState();
  const [newPriceId, setNewPriceId] = useState(null);
  const [priceState, setPriceState] = useState();
  const [numUsers, setNumUsers] = useState(1);
  const [downgradeDetailsDialog, setDowngradeDetailsDialog] = useState(false);
  const [subChangeDialog, setSubChangeDialog] = useState(false);
  const [verificationLoader, setVerificationLoader] = useState(false);
  const [customerBalance, setCustomerBalance] = useState();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [details, setDetails] = useState(null);
  const [verificationRequired, setVerificationRequired] = useState({});
  const [selectedPaymentmethodId, setSelectedPaymentMethodId] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [planInfo, setPlanInfo] = useState({planName: null, description: null, amount: null, yearly: false});
  const [existingPaymentMethod, setExistinPaymentMethod] = useState({open: false, newPriceId: null});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [directPaymentSuccess, setDirectPaymentSuccess] = useState(false);
  const [temptPaymentData, setTemptPaymentData] = useState({
    open: false,
    newPriceId: existingPaymentMethod?.newPriceId,
    newAmounts: null,
    data: null,
    daysUsed: 0,
    daysRemaining: 0,
    amountToPay: 0,
    finalAmountDue: 0,
    creditAmounts: 0,
    planUnitAmount: 0,
    billingLabel: "",
    plansDetail: null,
  });
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { toast } = useToast();
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";
  const isMobile = useMediaQuery('(max-width:767px)');

  const PRICING_CONFIG = {
    prod: {
      allowedPriceIds: [
        "price_1RsdHLHPX5Uwv3eVePGNLRLj",
        "price_1RsdPgHPX5Uwv3eV7k7eyln8",
        "price_1RsdVFHPX5Uwv3eVbavvVBji",
        "price_1RsdLlHPX5Uwv3eV3ozmcddw",
        "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
        "price_1RsdVaHPX5Uwv3eVGScEMH75",
      ],
      tiers: {
        STANDARD: [
          "price_1RsdHLHPX5Uwv3eVePGNLRLj",
          "price_1RsdLlHPX5Uwv3eV3ozmcddw",
        ],
        PLUS: [
          "price_1RsdPgHPX5Uwv3eV7k7eyln8",
          "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
        ],
        PROFESSIONAL: [
          "price_1RsdVFHPX5Uwv3eVbavvVBji",
          "price_1RsdVaHPX5Uwv3eVGScEMH75",
        ],
      },
      priceMapping: {
        Standard: {
          monthly: "price_1RsdHLHPX5Uwv3eVePGNLRLj",
          yearly: "price_1RsdLlHPX5Uwv3eV3ozmcddw",
        },
        Plus: {
          monthly: "price_1RsdPgHPX5Uwv3eV7k7eyln8",
          yearly: "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
        },
        Professional: {
          monthly: "price_1RsdVFHPX5Uwv3eVbavvVBji",
          yearly: "price_1RsdVaHPX5Uwv3eVGScEMH75",
        },
      },
    },
    dev: {
      allowedPriceIds: [
        "price_1RY2GjH54HzvHwSd7xIHfw9Z",
        "price_1RY2L2H54HzvHwSdeCNKydVJ",
        "price_1RY2SdH54HzvHwSdE62LQFMq",
        "price_1RYSEYH54HzvHwSdWnZO85Pk",
        "price_1RYSH0H54HzvHwSdPNwhG0Zf",
        "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
      ],
      tiers: {
        STANDARD: [
          "price_1RY2GjH54HzvHwSd7xIHfw9Z",
          "price_1RYSEYH54HzvHwSdWnZO85Pk",
        ],
        PLUS: [
          "price_1RY2L2H54HzvHwSdeCNKydVJ",
          "price_1RYSH0H54HzvHwSdPNwhG0Zf",
        ],
        PROFESSIONAL: [
          "price_1RY2SdH54HzvHwSdE62LQFMq",
          "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
        ],
      },
      priceMapping: {
        Standard: {
          monthly: "price_1RY2GjH54HzvHwSd7xIHfw9Z",
          yearly: "price_1RYSEYH54HzvHwSdWnZO85Pk",
        },
        Plus: {
          monthly: "price_1RY2L2H54HzvHwSdeCNKydVJ",
          yearly: "price_1RYSH0H54HzvHwSdPNwhG0Zf",
        },
        Professional: {
          monthly: "price_1RY2SdH54HzvHwSdE62LQFMq",
          yearly: "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
        },
      },
    },
    stage: {
      allowedPriceIds: [
        "price_1Rg4StHG9KfCFcBtk62AyLjl",
        "price_1Rg4VOHG9KfCFcBtUdpounGQ",
        "price_1Rg4YeHG9KfCFcBthKGhErSl",
        "price_1Rg4TIHG9KfCFcBti234fUD6",
        "price_1Rg4VsHG9KfCFcBtOKbt91yg",
        "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
      ],
      tiers: {
        STANDARD: [
          "price_1Rg4StHG9KfCFcBtk62AyLjl",
          "price_1Rg4TIHG9KfCFcBti234fUD6",
        ],
        PLUS: [
          "price_1Rg4VOHG9KfCFcBtUdpounGQ",
          "price_1Rg4VsHG9KfCFcBtOKbt91yg",
        ],
        PROFESSIONAL: [
          "price_1Rg4YeHG9KfCFcBthKGhErSl",
          "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
        ],
      },
      priceMapping: {
        Standard: {
          monthly: "price_1Rg4StHG9KfCFcBtk62AyLjl",
          yearly: "price_1Rg4TIHG9KfCFcBti234fUD6",
        },
        Plus: {
          monthly: "price_1Rg4VOHG9KfCFcBtUdpounGQ",
          yearly: "price_1Rg4VsHG9KfCFcBtOKbt91yg",
        },
        Professional: {
          monthly: "price_1Rg4YeHG9KfCFcBthKGhErSl",
          yearly: "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
        },
      },
    },
  };

  const { allowedPriceIds, tiers, priceMapping } = PRICING_CONFIG[ENV];

  const userLimits = {
    STANDARD: 5,
    PLUS: 10,
    PROFESSIONAL: 20,
  };

  const storageLimits = {
    STANDARD: 50 * 1024 * 1024 * 1024,
    PLUS: 100 * 1024 * 1024 * 1024,
    PROFESSIONAL: 200 * 1024 * 1024 * 1024,
  };

  const downgradeAccess = async (id) => {
    const { tiers } = PRICING_CONFIG[ENV];

    let tier = null;
    for (const key in tiers) {
      if (tiers[key].includes(id)) {
        tier = key;
        break;
      }
    }

    return {
      userLimit: userLimits[tier] || 0,
      storageLimits: storageLimits[tier] || 0,
      id,
    };
  };

  function getPriceDisplay(priceId) {
    const priceObj = prices.find((p) => p.id === priceId);
    if (!priceObj) return null;
    const adjustedAmount = priceObj.unit_amount * 10;
    const oldAmount = (adjustedAmount / 100).toFixed(2);
    const newAmount = (adjustedAmount / 12 / 100).toFixed(2);
    return { oldAmount, newAmount };
  }

  function getPriceDisplayPrice(priceId) {
    const priceObj =
      prices.find((p) => p.id === priceId) ||
      yearlyPrice.find((p) => p.id === priceId);

    if (!priceObj) return null;
    const newAmount = priceObj.unit_amount.toFixed(2);
    return newAmount;
  }

  useEffect(() => {
    commonContext?.setLoader(true);
    const loadStripeConfig = async () => {
      const result = await getStripeConfigs();
      if (result.success) {
        const filtered = result?.data?.prices.filter(
          (item) => allowedPriceIds?.includes(item.id) && item.active === true
        );

        const sorted = allowedPriceIds
          ?.map((id) =>
            filtered?.find(
              (item) => item.id === id && item.recurring.interval === "month"
            )
          )
          .filter(Boolean);

        const sortedYearly = allowedPriceIds
          ?.map((id) =>
            filtered?.find(
              (item) => item.id === id && item.recurring.interval === "year"
            )
          )
          .filter(Boolean);

        setPrices(sorted);
        setYearlyPrices(sortedYearly);
        commonContext?.setLoader(false);
      } else {
        console.error(result.error);
        commonContext?.setLoader(false);
      }
    };

    loadStripeConfig();
  }, []);

  useEffect(() => {
    const fetchCustomerBalance = async () => {
      try {
        const customerID = auth?.userProfile?.customer;
        if (!customerID) return;

        const [balance] = await Promise.all([
          getCustomerBalanceAmount(customerID),
        ]);

        setCustomerBalance(balance);
        const cardsData = auth?.userProfile?.cardsData?.cards?.filter((item) => item?.status !== "pending") || [];
        setPaymentMethods({
          defaultPaymentMethodId: auth?.userProfile?.cardsData?.defaultPaymentMethodId || null,
          cards: cardsData,
        });
      } catch (error) {
        console.error("Failed to fetch customer balance:", error);
      }
    };

    fetchCustomerBalance();
  }, [auth]);

  useEffect(() => {
    if (auth?.userProfile?.subscriptionDetails?.plan?.interval === "year") {
      setIsAnnual(true);
    } else {
      setIsAnnual(false);
    }
  }, []);

  const handleNavigate = () => {
    navigate("/dashboard");
    setDirectPaymentSuccess(false);
    setPaymentSuccess(false);
    setNewPriceId();
    auth?.setsubstatus(false);
    window.location.reload();
  };

  const handleCloseDetailsDowngrade = () => {
    setDowngradeDetailsDialog(false);
    setSubChangeDialog(false);
    setClientSecret(null);
    setNewPrice(null);
    navigate("/dashboard");
    setDetails(null);
    setPaymentSuccess(false);
    setNewPriceId();
    window.location.reload();
  };

  const handleCloseDowngrade = () => {
    setDownGradeDialog(false);
    setMessage("");
  };

  const handleQuantityStripeSubscription = async () => {
    commonContext?.setLoader(true);
    const customerId = auth?.userProfile?.customer;
    const result = await UpgradeQuantitySubscription(
      customerId,
      newPrice,
      code,
      numUsers
    );
    commonContext?.setLoader(false);
    if (result?.status === 200) {
      const { amount, error } = await getAmounts(result?.data?.clientSecret);
      setNewAmounts(amount);
      setNewPriceId(newPrice);
      setClientSecret(result?.data);
    } else {
      setClientSecret(null);
      setNewAmounts();
    }
  };

  const handleUpdateStripeSubscription = async (newPriceId) => {
    try {
      commonContext?.setLoader(true);
  
      const subscriptionId = auth?.userProfile?.subscriptionDetails?.id ||
        auth?.userProfile?.subscriptions?.data?.[0]?.id;
  
      const storage = auth?.userProfile?.storage || 0;
      const userLimit = auth?.userProfile?.companyActiveUsers || 0;
      const currentPlanId = auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id;
  
      const [newPlan, oldPlan] = await Promise.all([
        downgradeAccess(newPriceId),
        downgradeAccess(currentPlanId),
      ]);
          
      const exceedsStorage = storage > newPlan?.storageLimits;
      const exceedsUsers = userLimit > newPlan?.userLimit;
  
      const isDowngrade = newPlan?.userLimit < oldPlan?.userLimit;
      const usersToDisable = userLimit - newPlan?.userLimit;
      if (isDowngrade && (exceedsStorage || exceedsUsers)) {
        const message = exceedsStorage
          ? "Your current storage usage exceeds the limit of the selected plan. Please reduce your storage before downgrading."
          : `Your company currently has ${userLimit} active users, which exceeds the limit of ${newPlan?.userLimit} allowed by the selected plan. Please disable ${usersToDisable} user(s) to proceed with the downgrade.`;
        setMessage(message);
        setDownGradeDialog(true);
        return;
      }

      const data = await calculateSubscriptionPayment(subscriptionId, newPriceId, code);

      if (data.finalAmountDue > 0) {
        if (paymentMethods && paymentMethods?.cards?.length > 0) {
          setExistinPaymentMethod({open: true, newPriceId: newPriceId});
          return;
        } else {
          const result = await UpgradeStripeSubscription(subscriptionId, newPriceId, code);

          if (result?.status === 200) {
            const { amount } = await getAmounts(result?.data?.clientSecret);
            setNewAmounts(amount);
            setNewPriceId(newPriceId);
            setClientSecret(result?.data);
          }
        }

        commonContext?.setLoader(false);
        return;
      }

      const result = await UpgradeStripeSubscription(subscriptionId, newPriceId, code);
        if (result?.status === 200 && result?.downgrade === true) {
          const formData = {
            email: auth?.userProfile?.email,
            name: auth?.userProfile?.firstName,
            companyName: auth?.userProfile?.companyName,
          };

          await delay(5500);
          await SuccesDownGradeEmail(formData, result?.data, subscriptionId);

          setDowngradeDetailsDialog(true);
          setDetails(result?.data);
        } else if (result?.status === 200 && result?.switch === true) {
          const formData = {
            email: auth?.userProfile?.email,
            name: auth?.userProfile?.firstName,
          }
          await delay(5500);
          await SuccesUpdateSubscriptionEmail(formData);

          setSubChangeDialog(true);
        }
    } catch (error) {
      console.error("Subscription update failed:", error);
      resetBillingState();
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handleConfirmPaymentList = async () => {
    const subscriptionId = auth?.userProfile?.subscriptionDetails?.id || auth?.userProfile?.subscriptions?.data?.[0]?.id;
  
    const result = await UpgradeStripeSubscription(subscriptionId, existingPaymentMethod?.newPriceId, code);
    const { amount } = await getAmounts(result?.data?.clientSecret);

    const priceId = newPrice || existingPaymentMethod?.newPriceId;
    
    const daysUsed = result?.data?.daysUsed ?? 0;
    const plan = isAnnual ? yearlyPrice : prices;

    const plansDetail = plan?.find((item) => item.id === priceId);
    const daysRemaining = result?.data?.daysRemaining ?? (plansDetail?.recurring?.interval === "year" ? 365 - daysUsed : 30 - daysUsed); 
    const amountToPay = result?.data?.amountToPay ?? result?.data?.finalAmountDue ?? 0; 
    const finalAmountDue = result?.data?.finalAmountDue ?? amountToPay; 
    const creditAmounts = (result?.data?.creditFromOldPlan ?? 0) - (result?.data?.creditFromOldSubscription ?? 0); 
    const planUnitAmount = plansDetail?.unit_amount ?? 0; 
    const billingLabel = plansDetail?.recurring?.interval === "month" ? "Monthly" : "Annual (Save 16.67%)";
     setTemptPaymentData({
      open: true,
      newPriceId: existingPaymentMethod?.newPriceId,
      newAmounts: amount,
      data: result?.data,
      daysUsed,
      daysRemaining,
      amountToPay,
      finalAmountDue,
      creditAmounts,
      planUnitAmount,
      billingLabel,
      plansDetail,
    });
    setIsProcessing(false);
  }
  
  const resetBillingState = () => {
    setClientSecret(null);
    setNewPriceId(null);
    setNewAmounts(null);
  };
  

  const handleBillingToggle = () => {
    setIsAnnual(!isAnnual);
  };

  const handleApply = async () => {
    commonContext?.setLoader(true);
    try {
      const priceDetails = {};
      let discountData = null;

      if (code) {
        discountData = await getPromotionCodes(code);

        if (!discountData) {
          commonContext?.setLoader(false);
          toast({
            title: "Error",
            description: "Invalid promo code.",
            variant: "destructive",
          });
          setCode();
          return;
        }
      }

      for (const planName in priceMapping) {
        const priceIds = priceMapping[planName];

        const monthlyPriceInfo = getPriceDisplayPrice(priceIds.monthly);
        const yearlyPriceInfo = getPriceDisplayPrice(priceIds.yearly);

        const monthlyAmount = parseFloat(monthlyPriceInfo);
        const yearlyAmount = parseFloat(yearlyPriceInfo);

        let discountedMonthlyPrice = monthlyAmount;
        let discountedYearlyPrice = yearlyAmount;

        if (discountData) {
          if (discountData.type === "amount") {
            discountedMonthlyPrice = (
              monthlyAmount -
              discountData.value / 100
            ).toFixed(2);
            discountedYearlyPrice = (
              yearlyAmount -
              discountData.value / 100
            ).toFixed(2);
          } else if (discountData.type === "percent") {
            discountedMonthlyPrice = (
              monthlyAmount *
              (1 - discountData.value / 100)
            ).toFixed(2);
            discountedYearlyPrice = (
              yearlyAmount *
              (1 - discountData.value / 100)
            ).toFixed(2);
          }
        }

        priceDetails[planName] = {
          monthly: discountedMonthlyPrice,
          yearly: discountedYearlyPrice,
        };
      }
      setPriceState(priceDetails);
      commonContext?.setLoader(false);
      return priceDetails;
    } catch (error) {
      console.error("Error applying discount:", error);
      commonContext?.setLoader(false);
    }
  };

  const handleVerificationSuccess = async () => {
    try {
      const customerId = auth?.userProfile?.customer;
      const pendingData = auth?.userProfile?.pendingVerifications?.[0] || {};

      const verificationDocId = pendingData?.id;
      const newPriceId = pendingData?.newPriceId;
      const newAmounts = pendingData?.newAmounts;

      if (!verificationDocId) {
        console.error("Missing verification document ID");
        setVerificationLoader(false);
        return;
      }

      await Promise.all([
        updatePaymentVerification(verificationDocId),
        sendEmailForAchPaymentDetail(newPriceId, customerId, newAmounts)
      ]);

      toast?.({
        title: "Bank Account Verified",
        description:
          "Your bank account has been successfully verified. ACH payment is now processing.",
        variant: "default",
      });

      setVerificationRequired({
        open: false,
        type: null,
        paymentIntentId: null,
      });
      setPaymentSuccess(true);
      setNewPriceId();
    } catch (error) {
      console.error("ACH verification failed:", error);
    } finally {
      setVerificationLoader(false);
    }
  };

  return (
    <>
    {directPaymentSuccess === false && (
      <PageTitle
        pageTitle="Plans"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Account" }]}
        BreadCrumbCurrentPageTitle={"Plans"}
        showLastSeen={true}
      />
      )}
      <div className="p-25">
        {directPaymentSuccess === false ? (
        newPriceId === null ? (
          <>
            {auth?.userProfile?.pendingVerifications &&
              auth?.userProfile?.pendingVerifications?.length > 0 && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      background: "#FFF4E5",
                      border: "1px solid #F4A261",
                      borderRadius: "8px",
                      marginTop: "10px",
                      marginBottom: "20px",
                      width: "fit-content",
                      gap: "12px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#7A4E00",
                      }}
                    >
                      Your bank account needs verification before we can process
                      your subscription.
                    </span>

                    <Button
                      variant="contained"
                      onClick={() => {
                        setVerificationRequired({
                          open: true,
                          type: auth?.userProfile?.pendingVerifications?.[0]
                            ?.verificationType,
                          paymentIntentId:
                            auth?.userProfile?.pendingVerifications?.[0]
                              ?.paymentIntentId,
                        });
                      }}
                      style={{
                        backgroundColor: "#16A34A",
                        color: "white",
                        padding: "6px 16px",
                        textTransform: "none",
                      }}
                    >
                      {verificationLoader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        "Verify Now"
                      )}
                    </Button>
                  </div>
                </div>
              )}

            <div class="upgrade-box dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white">
              <h1>Select The Best Plan For Your Business</h1>
              <p className="dark:text-[#6B7280]">
                Join thousands of businesses that trust Pro Teams to manage
                their operations effectively. Unlock all features and take your
                business to the next level.
              </p>
            </div>

            <div
              className={
                isMobile
                  ? "d-flex flex-direction-column"
                  : "d-flex flex-center flex-space-between"
              }
            >
              <div
                className={`${styles.container} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
              >
                <div className={styles.switchRow}>
                  <span
                    className={`${styles.optionText} ${
                      !isAnnual ? styles.activeText : styles.inactiveText
                    }`}
                  >
                    Monthly
                  </span>
                  <div className={styles.switchWrapper}>
                    <AntSwitch
                      checked={isAnnual}
                      onChange={handleBillingToggle}
                      color="primary"
                      name="switchStatus"
                      inputProps={{ "aria-label": "switchStatus" }}
                    />
                  </div>
                  <span
                    className={`${styles.optionText} ${
                      isAnnual ? styles.activeText : styles.inactiveText
                    }`}
                  >
                    Annual
                  </span>
                  <span className={styles.badge}>
                    Save 17% on Annual billing
                  </span>
                </div>
              </div>
              <div
                className={`${styles.container} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
              >
                <div className={`${styles.promoContainer}`}>
                  <p className={styles.promoText}>Have a promo code?</p>
                  <input
                    type="text"
                    placeholder="Enter code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className={`${styles.promoInput} bg-white dark:bg-[#1A1F2C] text-black dark:text-white`}
                  />
                  <Button
                    className={styles.applyButton}
                    onClick={handleApply}
                    disabled={!code?.trim()}
                    variant="contained"
                    style={{ color: "white", backgroundColor: "green" }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>

            <SubscriptionList
              prices={prices}
              isAnnual={isAnnual}
              yearlyPrice={yearlyPrice}
              numUsers={numUsers}
              setNewPrice={setNewPrice}
              setNewPriceId={setNewPriceId}
              handleUpdateStripeSubscription={handleUpdateStripeSubscription}
              loader={loader}
              priceState={priceState}
              customerBalance={customerBalance}
              newPrice={newPrice}
              setPlanInfo={setPlanInfo}
            />

            <FeatureComparison isOpen={isOpen} setIsOpen={setIsOpen} />

            <TestimonialPage />
          </>
        ) : (
          <Elements stripe={stripePromise}>
            <PaymentFlowContet
              plan={isAnnual ? yearlyPrice : prices}
              loader={loader}
              setName={setName}
              name={name}
              // handleSubmit={handleSubmit}
              newPrice={newPrice}
              newAmounts={newAmounts}
              setClientSecret={setClientSecret}
              clientSecret={clientSecret}
              handleQuantityStripeSubscription={
                handleQuantityStripeSubscription
              }
              setNumUsers={setNumUsers}
              numUsers={numUsers}
              priceState={priceState}
              paymentSuccess={paymentSuccess}
              setPaymentSuccess={setPaymentSuccess}
              handleNavigate={handleNavigate}
              setLoader={setLoader}
              newPriceId={newPriceId}
              setNewPriceId={setNewPriceId}
              verificationRequired={verificationRequired}
              setVerificationRequired={setVerificationRequired}
            />
          </Elements>
        )) : (
          <PaymentSuccess
            handleNavigate={handleNavigate}
            plansDetail={temptPaymentData?.plansDetail}
            paymentMethod={selectedPaymentMethod?.type}
          />
        )}
      </div>
      {downgradeDialog && (
        <DownGradeDiaog
          open={downgradeDialog}
          onClose={handleCloseDowngrade}
          message={message}
        />
      )}
      {downgradeDetailsDialog && (
        <SuccessDowngradeDialog
          open={downgradeDetailsDialog}
          onClose={handleCloseDetailsDowngrade}
          data={details}
          change={false}
        />
      )}
      {subChangeDialog && (
        <SuccessDowngradeDialog
          open={subChangeDialog}
          onClose={handleCloseDetailsDowngrade}
          data={details}
          change={true}
        />
      )}

      {verificationRequired?.open && (
        <ACHVerification
          open={verificationRequired?.open}
          type={verificationRequired?.type}
          paymentIntentId={verificationRequired?.paymentIntentId}
          onSuccess={handleVerificationSuccess}
          onClose={() =>
            setVerificationRequired({
              open: false,
              type: null,
              paymentIntentId: null,
            })
          }
          verificationLoader={verificationLoader}
          setVerificationLoader={setVerificationLoader}
        />
      )}

      {existingPaymentMethod?.open && (
        <Elements stripe={stripePromise}>
        <PaymentMethodsList
          open={existingPaymentMethod?.open}
          onClose={() => { setExistinPaymentMethod({open: false, newPriceId: null}); setPlanInfo({planName: null, description: null, amount: null, yearly: false}); }}
          onConfirm={() => handleConfirmPaymentList()}
          paymentMethods={paymentMethods}
          planInfo={planInfo}
          temptPaymentData={temptPaymentData}
          setTemptPaymentData={setTemptPaymentData}
          setSelectedPaymentMethodId={setSelectedPaymentMethodId}
          selectedPaymentmethodId={selectedPaymentmethodId}
          setIsProcessing={setIsProcessing}
          isProcessing={isProcessing}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          selectedPaymentMethod={selectedPaymentMethod}
          setPaymentSuccess={setDirectPaymentSuccess}
        />
        </Elements>
      )}
    </>
  );
};

export default UpgradePage;
